// Saga for shortcut apps
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

// Redux States

import {
  GET_SHORTCUT_APPS_LIST,
  GET_SHORTCUT_APP_DATA,
  CREATE_SHORTCUT_APP_DATA,
  UPDATE_SHORTCUT_APP_DATA,
  DELETE_SHORTCUT_APP_DATA,
} from "./actionType";

// Action methods

import {
  getShortcutAppsListSuccess,
  getShortcutAppsListError,
  getShortcutAppDataSuccess,
  getShortcutAppDataError,
  createShortcutAppDataSuccess,
  createShortcutAppDataError,
  updateShortcutAppDataSuccess,
  updateShortcutAppDataError,
  deleteShortcutAppDataSuccess,
  deleteShortcutAppDataError,
} from "./action";

// API methods

import {
  getShortcutsAppsListApiCall,
  getShortcutAppDataApiCall,
  createShortcutAppDataApiCall,
  updateShortcutAppDataApiCall,
  deleteShortcutAppDataApiCall,
} from "../../helpers/fakebackend_helper";

// Get shortcut apps list api
function* getShortcutAppsListApi() {
  try {
    const response = yield call(getShortcutsAppsListApiCall);
    yield put(getShortcutAppsListSuccess(response));
  } catch (error) {
    yield put(getShortcutAppsListError(error));
  }
}

// watcher for get shortcut apps list api
export function* getShortcutAppsListWatcher() {
  yield takeEvery(GET_SHORTCUT_APPS_LIST, getShortcutAppsListApi);
}

// Get shortcut app data api
function* getShortcutAppDataApi({ payload: data }) {
  try {
    const response = yield call(getShortcutAppDataApiCall, data);
    yield put(getShortcutAppDataSuccess(response));
  } catch (error) {
    yield put(getShortcutAppDataError(error));
  }
}

// watcher for get shortcut app data api
export function* getShortcutAppDataWatcher() {
  yield takeEvery(GET_SHORTCUT_APP_DATA, getShortcutAppDataApi);
}

// Create shortcut app data api
function* createShortcutAppDataApi({ payload: data }) {
  try {
    const response = yield call(createShortcutAppDataApiCall, data);
    yield put(createShortcutAppDataSuccess(response));
  } catch (error) {
    yield put(createShortcutAppDataError(error));
  }
}

// watcher for create shortcut app data api
export function* createShortcutAppDataWatcher() {
  yield takeEvery(CREATE_SHORTCUT_APP_DATA, createShortcutAppDataApi);
}

// Update shortcut app data api
function* updateShortcutAppDataApi({ payload: data }) {
  try {
    const response = yield call(updateShortcutAppDataApiCall, data);
    yield put(updateShortcutAppDataSuccess(response));
  } catch (error) {
    yield put(updateShortcutAppDataError(error));
  }
}

// watcher for update shortcut app data api
export function* updateShortcutAppDataWatcher() {
  yield takeEvery(UPDATE_SHORTCUT_APP_DATA, updateShortcutAppDataApi);
}

// Delete shortcut app data api
function* deleteShortcutAppDataApi({ payload: data }) {
  try {
    const response = yield call(deleteShortcutAppDataApiCall, data);
    yield put(deleteShortcutAppDataSuccess(response));
  } catch (error) {
    yield put(deleteShortcutAppDataError(error));
  }
}

// watcher for delete shortcut app data api
export function* deleteShortcutAppDataWatcher() {
  yield takeEvery(DELETE_SHORTCUT_APP_DATA, deleteShortcutAppDataApi);
}

// main saga function

function* ShortcutApps() {
  yield all([
    fork(getShortcutAppsListWatcher),
    fork(getShortcutAppDataWatcher),
    fork(createShortcutAppDataWatcher),
    fork(updateShortcutAppDataWatcher),
    fork(deleteShortcutAppDataWatcher),
  ]);
}

export default ShortcutApps;
